<div class="layout-breadcrumb">
  <ul id="breadcrumb">
    <li id="breadcrumb-home">
      <a routerLink="">
        <i class="pi pi-home"></i>
      </a>
    </li>
    <li>/</li>
    @for (item of items; track item; let last = $last) {
      <li>
        @if (item.routerLink) {
          <a [routerLink]="item.routerLink">{{
            item.label
          }}</a>
        }
        @if (!item.routerLink) {
          {{ item.label }}
        }
      </li>
      @if (!last) {
        <li>/</li>
      }
    }
  </ul>
</div>
